import { UIText2 } from '@cian/ui-kit';
import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectBuyPackageModalData, selectIsSubscription } from '../../../../../../../../selectors/buyPackageModal';
import { formatPoints } from '../../../../../../../../utils/string';
import { TableSeparator } from '../TableSeparator';
import { TableCell } from '../TableCell';

interface IAuctionPointsContainerProps {
  durationCol: boolean;
}

export const AuctionPointsContainer = (props: IAuctionPointsContainerProps) => {
  const { durationCol } = props;

  const { auctionPoints, totalAuctionPoints, cashback, cashbackPercent } = useSelector(selectBuyPackageModalData);
  const isSubscription = useSelector(selectIsSubscription);

  if (!isSubscription || !totalAuctionPoints) {
    return null;
  }

  const durationCell = durationCol && <TableCell />;

  return (
    <tbody>
      <TableSeparator />

      {!!auctionPoints && (
        <tr>
          <TableCell>
            <UIText2 whiteSpace="nowrap">Баллов в подписке</UIText2>
          </TableCell>
          {durationCell}
          <TableCell>
            <UIText2 whiteSpace="nowrap">{formatPoints(auctionPoints)}</UIText2>
          </TableCell>
          <TableCell />
        </tr>
      )}

      {!!cashback && (
        <tr>
          <TableCell>
            <UIText2 whiteSpace="nowrap">Кешбэк за покупку ({cashbackPercent}%)</UIText2>
          </TableCell>
          {durationCell}
          <TableCell>
            <UIText2 whiteSpace="nowrap">{formatPoints(cashback)}</UIText2>
          </TableCell>
          <TableCell />
        </tr>
      )}

      <tr>
        <TableCell>
          <UIText2 fontWeight="bold" whiteSpace="nowrap">
            Всего баллов
          </UIText2>
        </TableCell>
        {durationCell}
        <TableCell>
          <UIText2 fontWeight="bold" whiteSpace="nowrap">
            {formatPoints(totalAuctionPoints)}
          </UIText2>
        </TableCell>
        <TableCell />
      </tr>
    </tbody>
  );
};
